export default __webpack_public_path__ + "static/media/favicon.e4721b11.svg";